
import React, { useContext, useEffect } from "react";
import { ZendeskAPI } from '../../utils/ZendexConfig'
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";

function HelpSupport() {
  const { t } = useTranslation();
  const { updatePageName } = useContext(AuthContext)
  useEffect(() => {
    updatePageName(t('HELP_AND_SUPPORT'))
  }, [])
  return (
    <div className="pt-20 sm:pt-[100px] md:pt-[90px] pb-5 md:pb-10 ">

      <div className="max-w-[1051px] px-4 mx-auto">
        <div className="flex flex-wrap">
          <div className="flex-1  bg-white md:ms-[30px] ">
            <div className="max-w-[601px] mx-auto">

              <span className="w-full h-full sm:w-[294px] sm:h-[180px] mb-8 block">
                <img src="/images/support_chat.png" width={294} height={180} alt="help" />
              </span>
              <span className="w-[30px] h-[30px] mb-4 block">
                <img src="/images/smile.svg" width={30} height={30} alt="smile" />
              </span>
              <h3 className="text-theme-black font-semibold text-xl mb-2">{t('ASSISTANCE_AND_SUPPORT')}</h3>
              <p className="text-theme-black font-normal mb-4">{t('HELP_IS_ALWAYS_AVAILABLE')}</p>
              <div className=" py-4 px-5 bg-[#F3F3F3] rounded-2xl mb-6">

                <span onClick={() => ZendeskAPI("messenger", "open")}
                  className="flex items-center  relative cursor-pointer">
                  <div className="flex flex-col flex-1 pe-14">
                    <h6 className="text-theme-black  font-medium mb-2">{t('CHAT_WITH_US')}</h6>
                    <span className="text-theme-black text-sm font-normal max-w-[213px]">{t('CHAT_WITH_US_FOR_QUICK')}</span>
                  </div>
                  <span className="w-8 h-8  me-2.5 ] absolute right-0 top-1/2 -translate-y-1/2">
                    <img src="/images/help_chat.svg" width={32} height={32} alt="chat" />
                  </span>
                </span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpSupport;





